import React from 'react';
import { ArticleLayout } from '../../components/ArticleLayout';

export const SegmentationArticle: React.FC = () => {
    return (
        <ArticleLayout
            title="The Importance of Segmentation in Localization"
            subtitle="Why splitting text correctly matters for Translation Memory and quality."
        >
            <h3>What is Segmentation?</h3>
            <p>
                Segmentation is the process of breaking down a block of text (like a paragraph) into smaller, meaningful units
                (usually sentences). In localization, these units are stored in a Translation Memory (TM).
            </p>

            <h3>Why Excel Segmentation is Hard</h3>
            <p>
                In Excel, a single cell often contains a whole paragraph or multiple distinct thoughts.
                If you translate the cell as a whole, you get one big TM unit. If a single sentence in that paragraph changes later,
                the fuzzy match score drops significantly, increasing costs.
            </p>

            <h3>SRX Rules</h3>
            <p>
                SRX (Segmentation Rules eXchange) is a standard for defining how text should be split.
                Our converter supports custom SRX rules, allowing you to define exactly how your Excel content should be segmented.
                This ensures that your TM remains clean, granular, and highly reusable.
            </p>
        </ArticleLayout>
    );
};
